exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-switch-checked[data-v-33865093] {\n  background-color: #085FCE !important;\n}\n.switch[data-v-33865093] {\n  height: 39px;\n  display: flex;\n  align-items: center;\n}", ""]);

// exports
